import instance from '../../../../api/axios'
import { uploadFile } from '../../../Files/api/uploadFile'
import { FileItem } from '../../../Files/types/files'
import { CreateTrip, TripItem } from '../types/trip'

export const getTripFileUrl = (fileId: string) =>
  `${process.env.REACT_APP_MAIN_API_ROOT || ''}/files/download/${fileId}`

export const loadTrips = async (): Promise<TripItem[]> => {
  const response = await instance.get('/trips')
  return response.data
}

export const saveTrip = async (trip: CreateTrip): Promise<TripItem> => {
  const response = await instance.post('/trips', trip)
  return response.data
}

export const modifyTrip = async (trip: TripItem): Promise<TripItem> => {
  const response = await instance.put('/trips', trip)
  return response.data
}

export const removeTrip = async (id: string): Promise<string> => {
  const response = await instance.delete(`/trips/${id}`)
  return response.data
}

export const uploadTripImage = async (file: File): Promise<string> => {
  const uploaded = await uploadFile({
    file,
    name: file.name,
    description: '',
    isPublic: true,
  })

  return getTripFileUrl(uploaded.id)
}

export const uploadTripAttachment = async (
  file: File,
  tripId: string,
): Promise<FileItem> => {
  return uploadFile({
    file,
    name: file.name,
    description: '',
    isPublic: true,
    tripId,
  })
}
